import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { of } from 'rxjs'
import { Guest } from '@tv3/store/guest/guest.model'
import { Rental } from '@tokeet-frontend/tv3-platform'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'

@Injectable({ providedIn: 'root' })
export class SignatureDataSampleService {
  cache: any = {}

  constructor(private http: HttpClient) {}

  private get<D = any>(url: string) {
    if (this.cache[url]) {
      return of(this.cache[url] as D)
    }
    return this.http.get<D>(url).pipe()
  }

  rental() {
    return this.get<Rental>(`/assets/samples/rental.json`)
  }

  guest() {
    return this.get<Guest>(`/assets/samples/guest.json`)
  }

  inquiry() {
    return this.get<Inquiry>(`/assets/samples/inquiry.json`)
  }
}
